namespace Portico.Models.Enterprise {

    export interface ISurvey {
        description: string;
        surveyId: number | string;
        surveyTypeId: number;
        surveyQuestions: SurveyQuestion[];

		getSurveyAnswer: (questionId: number, answerId: number) => SurveyAnswer;
		getSurveyQuestion: (questionId: number) => SurveyQuestion;
	}

    export class Survey implements ISurvey {
        description: string;
		surveyId: number | string;
        surveyTypeId: number;
        surveyQuestions: SurveyQuestion[];

        constructor(obj?: ISurvey | any) {
            this.description = null;
            this.surveyId = null;
            this.surveyTypeId = null;
			this.surveyQuestions = [];

            if (obj) {
                this.description = obj.description || null;
                this.surveyId = obj.surveyId || null;
                this.surveyTypeId = obj.surveyTypeId || null;

				if (obj.surveyQuestions || obj.questionsWithAnswers) {
					for (const surveyQuestion of obj.surveyQuestions || obj.questionsWithAnswers) {
                        this.surveyQuestions.push(new SurveyQuestion(surveyQuestion));
                    }
                }
            }
		}

		getSurveyAnswer(questionId: number, answerId: number): SurveyAnswer {
			const surveyQuestion = this.getSurveyQuestion(questionId);
			const surveyAnswer = surveyQuestion.getSurveyAnswer(answerId);

			return surveyAnswer;
		}

		getSurveyQuestion(questionId: number): SurveyQuestion {
			for (const surveyQuestion of this.surveyQuestions) {
				if (surveyQuestion.questionId === questionId) {
					return surveyQuestion;
				}
			}

			return null;
		}
    }
}
